import { captureException } from '@/utils/sentry';
import { Fennel } from '@/analytics/fennel/fennel';
import {
  SalesPortalAnalyticEvent,
  SalesPortalAnalyticPayloads,
  salesPortalEventsMetadata,
} from './registry';

export const track = <E extends SalesPortalAnalyticEvent>(
  event: E,
  payload: SalesPortalAnalyticPayloads[E],
): void => {
  const initialized = Fennel.getInstance().getInitializationState();

  if (!initialized) {
    console.warn('Fennel tracker not initialized. Call initialize() first.');
    captureException(
      new Error('Fennel tracker not initialized. Call initialize() first.'),
    );
    return;
  }

  const meta = salesPortalEventsMetadata[event];
  initialized.engine.track(meta.eventName, {
    ...initialized.state,
    ...payload,
  });
};
